module.exports = __webpack_public_path__ + "static/media/assa-thumbsup.c4f7ced0.svg";